import React from "react";
import OutwaredBinReportTable from "../../Comman/OutwaredBinReportTable";

const DS_OutwaredBin = ({ userData }) => {
  return <OutwaredBinReportTable location="dispatch_center" />;
};

export default DS_OutwaredBin;